<template>
    <div>
        <div class="modal-overlay" v-if="isModalOpen" @click="fecharModal"></div>
        <div class="notification-modal" v-if="isModalOpen">
            <v-card >
                <v-card-title class="notification-title pa-2"><p class="pa-0 mb-0">Notificações</p></v-card-title>
                <v-card-text class="notification-wrapper-modal">
                    <div class="notification-text" v-show="notificationList.length > 0" v-for="(item, index) in notificationList ">
                        <p>Nova solicitação de endosso para apólice N° <span class="proposta-redirecionar" @click="abrirEndosso(item.idApolice)">{{item.numeroProposta}}</span></p>
                    </div> 
                    <div v-show="notificationList.length == 0">Sem notificações</div>
                </v-card-text>
                <v-card-actions class=""> 
                    <div class="notification-actions">
                        <v-btn class="btn-fechar" color="primary" flat @click="fecharModal">
                            Fechar
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </div>
    </div>
    
</template>
<script>
export default {
    name: "Notification",
    data: function () {
        return {
            isModalOpen: false
        }
    },
    props: {
        notificationList: Array,
        abrirModal: Boolean
    },
    watch : {
        abrirModal(newVal) {
            this.isModalOpen = newVal;
        }
    },
    methods: {
        abrirEndosso(id) {
            this.isModalOpen = false;
            this.$emit("fecharModalNotificacao");

            this.$router.push("/GridPrincipal/InfoGerais/GridEndossos?id=" + id);
        },
        fecharModal() {
            this.$emit("fecharModalNotificacao");
        }
    },
    
   
}
</script>
<style>
.notification-modal{
    width: 330px;
    position: absolute;
    z-index: 99 !important;
    top: 10px;
    right: 2%;
    
}
.notification-wrapper-modal {
    max-height: 230px;
    overflow: hidden;
    overflow-y: scroll;
}
.proposta-redirecionar:hover {
    text-decoration: underline;
    cursor: pointer;
}
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
    z-index: 98;
}
.notification-title {
    background-color: #00456e;
    text-align: center;
}
.notification-title  p{
    width: 100%;
    text-align: center;
    color: white;
    font-size: 17px;
    font-weight: 600;
}
.notification-modal .v-card {
    border-radius: 6px;
}
.notification-actions {
    width: 100%;
    display: flex;
    justify-content: center;
    border-top: 1px solid rgb(119, 111, 111);
    flex-direction: column;
    margin-top: 6px;
}
.btn-fechar {
    margin-top: 10px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/Notification.vue